import React, { PropTypes } from 'react';
import Tile from 'common/page/buckets/Tile';
import InContentAd from 'common/ads/InContentAd';

const placementPrefix = 'playback-page-recommended-';

const TabPane = ({ active, bucketId, contents, name, showAds, tabIndex }) => {
    const ad = showAds ? (
        <InContentAd key="ad_incontent" exclude={['m']} refreshWhenVisible />
    ) : null;
    const items = contents.map((content) => (
        <Tile
            content={content}
            bucketId={bucketId}
            key={`tabPane${tabIndex}:${content.id}:${content.name}`}
            placement={`${placementPrefix}${name}`}
            bucketName={name}
        />
    ));
    if (ad) {
        items.splice(3, 0, ad);
    }
    return (
        <div className={`tab-pane ${active ? 'active' : ''}`}>
            <div className="collection collection--watch">
                <div className="collection_row">
                    {items}
                </div>
            </div>
        </div>
    );
};

TabPane.propTypes = {
    active: PropTypes.bool,
    bucketId: PropTypes.number,
    contents: PropTypes.array,
    name: PropTypes.string,
    showAds: PropTypes.bool,
    tabIndex: PropTypes.number
};

TabPane.defaultProps = {
    active: false,
    contents: [],
    name: 'unknown',
    showAds: false
};

export default TabPane;



// WEBPACK FOOTER //
// ./app/webapp/drawer/TabPane.js